import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationBadge = () => {
  return (
    <div className="bg-card border-2 border-primary rounded-[var(--radius-md)] p-6 md:p-8 lg:p-10">
      <div className="flex flex-col items-center text-center">
        <div 
          className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-full flex items-center justify-center mb-4 md:mb-6"
          style={{ 
            background: 'linear-gradient(135deg, rgba(0, 79, 152, 0.2) 0%, rgba(0, 79, 152, 0.05) 100%)',
            border: '3px solid var(--color-primary)'
          }}
        >
          <Icon
            name="ShieldCheck"
            size={48}
            color="var(--color-primary)"
            strokeWidth={2}
            className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14"
          />
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground font-heading mb-3 md:mb-4">
          Verifisert norsk tjeneste
        </h2>

        <p className="text-base md:text-lg text-muted-foreground font-body max-w-2xl mb-6 md:mb-8">
          Veiassistent er en offisielt verifisert og godkjent tjeneste i Norge. Vi overholder alle nasjonale forskrifter og standarder for veitjenester og databeskyttelse.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 w-full max-w-3xl">
          <div className="flex flex-col items-center p-4 bg-surface-elevated rounded-[var(--radius-sm)]">
            <Icon
              name="Award"
              size={32}
              color="var(--color-primary)"
              className="mb-3"
            />
            <span className="text-sm md:text-base font-medium text-foreground font-body">
              ISO-sertifisert
            </span>
          </div>

          <div className="flex flex-col items-center p-4 bg-surface-elevated rounded-[var(--radius-sm)]">
            <Icon
              name="Lock"
              size={32}
              color="var(--color-primary)"
              className="mb-3"
            />
            <span className="text-sm md:text-base font-medium text-foreground font-body">
              GDPR-kompatibel
            </span>
          </div>

          <div className="flex flex-col items-center p-4 bg-surface-elevated rounded-[var(--radius-sm)]">
            <Icon
              name="CheckCircle"
              size={32}
              color="var(--color-primary)"
              className="mb-3"
            />
            <span className="text-sm md:text-base font-medium text-foreground font-body">
              Norsk godkjent
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationBadge;